import { createFileRoute } from '@tanstack/react-router';
import { CampusResourcesScreen } from '@/screens/campusResource/CampusResourcesScreen';

export const Route = createFileRoute('/admin/campus-resources')({
  component: CampusResourcesScreen,
});